import React, { useState } from "react";
import PrivateNavbar from "../components/nav/PrivateNavbar";
import Sidebar from "../components/nav/Sidebar";

const PrivateLayout = ({ backgroundImage, children }) => {
  const [sidebarOpen, setSidebarOpen] = useState(false);

  return (
    <div
      style={{
        ...(backgroundImage
          ? {
              backgroundImage: `url(${backgroundImage})`,
              backgroundSize: "cover",
              backgroundPosition: "center",
            }
          : {}),
        height: "100vh",
        display: "flex",
        flexDirection: "column",
        overflow: "hidden",
      }}
    >
      <PrivateNavbar onToggleSidebar={() => setSidebarOpen((v) => !v)} />
      <div style={{ flex: 1, display: "flex", overflow: "hidden" }}>
        <Sidebar open={sidebarOpen} onClose={() => setSidebarOpen(false)} />
        <div style={{ flex: 1, overflowY: "auto" }}>{children}</div>
      </div>
    </div>
  );
};

export default PrivateLayout;
